/* Cortex PDP gallery add-ons - Nov 3 2026
   1) Desktop (900px+): 4 thumbnails in the vertical strip, mouse wheel / trackpad scrolls the strip,
      one quiet chevron at the bottom (styled in cortex-pdp-thumbs.css).
   2) Mobile: lets shoppers swipe the main photo.
   3) Color grouping: when a shopper picks a color, re-render the gallery so only that color's
      photos plus the shared photos show (the filtering itself lives in snippets/media-gallery-main.liquid).
   Loaded from snippets/cortex-choice-note.liquid. */
(function () {
  var DESK = window.matchMedia('(min-width: 900px)');

  function setup(gal) {
    var sw = gal.thumbsSwiper;
    if (!sw || sw.__cortexThumbs) return;
    sw.__cortexThumbs = true;

    if (gal.isVertical) {
      try {
        var bp = sw.params.breakpoints && sw.params.breakpoints[900];
        if (bp) bp.slidesPerView = 4;
        var obp = sw.originalParams && sw.originalParams.breakpoints && sw.originalParams.breakpoints[900];
        if (obp) obp.slidesPerView = 4;
        if (DESK.matches) sw.params.slidesPerView = 4;
        sw.update();
      } catch (e) {}

      gal.thumbSlider.addEventListener('wheel', function (e) {
        if (!DESK.matches || sw.destroyed) return;
        var min = sw.minTranslate(), max = sw.maxTranslate();
        if (min === max) return;
        var cur = sw.getTranslate();
        var next = Math.max(max, Math.min(min, cur - e.deltaY));
        if (next === cur) return; /* at the end: let the page scroll */
        e.preventDefault();
        sw.setTranslate(next);
        sw.updateProgress();
        sw.updateActiveIndex();
        sw.updateSlidesClasses();
        if (sw.navigation && sw.navigation.update) sw.navigation.update();
      }, { passive: false });
    }

    if (!DESK.matches && gal.swiper) gal.swiper.allowTouchMove = true;
  }

  document.addEventListener('media-slider-ready', function (e) {
    var gal = e.target && e.target.closest ? e.target.closest('media-gallery') : null;
    if (gal) setup(gal);
  }, true);

  document.querySelectorAll('media-gallery').forEach(function (g) {
    if (g.thumbsSwiper) setup(g);
  });

  /* 3) Color grouping on variant change */
  var seq = 0;
  document.addEventListener('variant-change', function (e) {
    var info = e.target && e.target.closest ? e.target.closest('product-info') : null;
    if (!info || info.dataset.mainProduct !== 'true') return;
    var root = info.closest('.product-main-inner');
    var pm = root && root.querySelector('product-media');
    if (!pm) return;
    var values = (e.detail && e.detail.selectedOptionValues) || [];
    var url = new URL(info.dataset.productUrl, window.location.origin);
    url.searchParams.set('option_values', values.join(','));
    url.searchParams.set('section_id', info.dataset.sectionId);
    var token = ++seq;
    fetch(url.toString()).then(function (r) { return r.text(); }).then(function (html) {
      if (token !== seq) return;
      var d = document.createElement('div');
      d.innerHTML = html;
      var fm = d.querySelector('product-media');
      if (!fm) return;
      var ids = function (el) { return Array.prototype.map.call(el.querySelectorAll('.main_media_slider_wrapper .product_media_wrapper'), function (x) { return x.dataset.mediaId; }).join('|'); };
      if (ids(pm) === ids(fm)) return; /* same photo set, nothing to swap */
      pm.innerHTML = fm.innerHTML; /* media-gallery re-initialises itself and fires media-slider-ready */
    }).catch(function () {});
  }, true);
})();
